export interface RecipientBankInfoDisplayValue {
  bank_name?: string | null;
  bank_account_number?: string | null;
  bank_account_holder?: string | null;
}

const EMPTY_FIELD = '-';
const SUKANDA_BCA_ACCOUNT_NUMBER = '6350069001';
const SUKANDA_BANK_ACCOUNT_HOLDER = 'SUKANDA DJAYA PT';

function normalizeRecipientValue(value?: string | null): string | null {
  const normalizedValue = value?.trim();

  if (!normalizedValue || normalizedValue === EMPTY_FIELD) {
    return null;
  }

  return normalizedValue;
}

export function formatRecipientBankInfo(
  recipientBankInfo?: RecipientBankInfoDisplayValue | null
): string {
  const recipientValues = [
    normalizeRecipientValue(recipientBankInfo?.bank_account_number),
    normalizeRecipientValue(recipientBankInfo?.bank_account_holder),
  ].filter((value): value is string => Boolean(value));

  if (recipientValues.length === 0) {
    return EMPTY_FIELD;
  }

  return recipientValues.join(' - ');
}

export function getRecipientBankInfoForDisplay(
  recipientBankInfo?: RecipientBankInfoDisplayValue | null,
  fallbackBankName?: string | null
): RecipientBankInfoDisplayValue | null {
  const accountNumber = normalizeRecipientValue(
    recipientBankInfo?.bank_account_number
  );

  if (accountNumber) {
    return {
      ...recipientBankInfo,
      bank_account_number: accountNumber,
      bank_account_holder: SUKANDA_BANK_ACCOUNT_HOLDER,
    };
  }

  const bankName = normalizeRecipientValue(
    recipientBankInfo?.bank_name ?? fallbackBankName
  );

  if (bankName?.toUpperCase() !== 'BCA') {
    return recipientBankInfo ?? null;
  }

  return {
    bank_name: bankName,
    bank_account_number: SUKANDA_BCA_ACCOUNT_NUMBER,
    bank_account_holder: SUKANDA_BANK_ACCOUNT_HOLDER,
  };
}
